import { render, staticRenderFns } from "./BodySidebar.vue?vue&type=template&id=5f2d7d10&scoped=true&"
import script from "./BodySidebar.vue?vue&type=script&lang=js&"
export * from "./BodySidebar.vue?vue&type=script&lang=js&"
import style0 from "./BodySidebar.vue?vue&type=style&index=0&id=5f2d7d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d7d10",
  null
  
)

export default component.exports